export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  
  const ellipsis = " ...";
  return text.slice(0, maxLength - ellipsis.length) + ellipsis;
};

export const formatUrl = (url: string): string => {
  if (!url) return url;
  
  // Remove any leading/trailing whitespace
  const trimmedUrl = url.trim();
  
  // Check if the URL already starts with http:// or https://
  if (/^https?:\/\//i.test(trimmedUrl)) {
    return trimmedUrl;
  }
  
  // Add https:// prefix
  return `https://${trimmedUrl}`;
};

export const getAvatarByUserId = (userId: string): string => {
  // Convert userId string to a number by summing char codes
  const sum = userId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  // Get a number between 1-18
  const avatarNumber = (sum % 18) + 1;
  return `${avatarNumber}.png`;
};
